<template>
    <li class="nav-item dropdown">
        <a class="nav-link count-indicator dropdown-toggle" id="notificationDropdown" href="#" data-toggle="dropdown">
            <i class="mdi mdi-bell-outline" :class="{shaky: hasUnreadNotifications}"></i>
            <span class="count-symbol bg-danger" v-if="hasUnreadNotifications"></span>
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="notificationDropdown">
            <h6 class="p-3 mb-0">{{ $t('pages.notifications.title') }}</h6>
            <div class="dropdown-divider"></div>

            <div v-for="notification in notifications">
                <a class="dropdown-item preview-item" :class="{'read': hasBeenRead(notification)}">
                    <div class="preview-thumbnail">
                        <div class="preview-icon" :class="notification.data.meta.type">
                            <i :class="notification.data.meta.icon"></i>
                        </div>
                    </div>
                    <div class="preview-item-content d-flex align-items-start flex-column justify-content-center" @click="$router.push({name: 'notifications'})">
                        <h6 class="preview-subject font-weight-normal mb-1">{{ notification.data.title }}</h6>
                        <p class="text-gray ellipsis mb-0" v-html="notification.data.text"></p>
                        <small class="mt-2">{{ $date(notification.created_at).format('DD.MM.YYYY HH:mm') }}</small>
                    </div>
                </a>

                <div class="dropdown-divider"></div>
            </div>

            <a class="dropdown-item preview-item read" v-if="!hasNotifications">
                <div class="preview-thumbnail">
                    <div class="preview-icon bg-dark">
                        <i class="mdi mdi-emoticon-happy"></i>
                    </div>
                </div>
                <div class="preview-item-content d-flex align-items-start flex-column justify-content-center">
                    <h6 class="preview-subject font-weight-normal mb-1">No Notifications</h6>
                </div>
            </a>

            <router-link tag="h6" class="p-3 mb-0 text-center cursor-pointer" :to="{name: 'notifications'}">
                {{ $t('pages.notifications.see_all') }}
            </router-link>
        </div>
    </li>
</template>

<script>
export default {
    name: "DashboardNotificationMenu",
    methods: {
        hasBeenRead(notification) {
          return notification.read_at !== null;
      }
    },
    computed: {
        notifications() {
            return this.$store.getters.notifications;
        },
        hasNotifications() {
            return this.notifications.length > 0;
        },
        hasUnreadNotifications() {
            return this.notifications.filter(notification => notification.read_at === null).length > 0;
        }
    }
}
</script>

<style scoped lang="scss">
    .read {
        background-color: #ececec;
        opacity: 0.4;
    }
</style>
